var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fix-padding", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { attrs: { lg: "12" } },
        [
          _c("v-breadcrumbs", {
            staticClass: "p-0",
            attrs: { items: _vm.breadcrumbs },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _vm.loading || _vm.infors.length > 0
            ? _c(
                "v-col",
                { staticClass: "pt-3 bg-white ms-3 me-3", attrs: { lg: "9" } },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-space-between align-items-center py-1",
                    },
                    [
                      _c("div", { staticClass: "text-large font-bold" }, [
                        _vm._v(" お知らせ "),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _vm.user
                          ? _c("div", { staticClass: "text-small" }, [
                              _vm._v(
                                " 未読: " +
                                  _vm._s(_vm.user.unreadInformationsCount) +
                                  "件 "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-small ms-2 border-default p-1 text-blue cursor-pointer",
                            on: { click: _vm.readAll },
                          },
                          [_vm._v("\n            すべて既読にする\n          ")]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _vm._l(_vm.infors, function (item) {
                    return [
                      _c("InformationView", {
                        key: "item-" + item.id,
                        attrs: { item: item },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.toInfo(item)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("v-divider", { key: "divider-" + item.id }),
                    ]
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center" },
                    [
                      _vm.loading
                        ? _c("v-progress-circular", {
                            staticClass: "loading",
                            attrs: { indeterminate: "", color: "green" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              )
            : _c("v-col", [_vm._v("\n      お知らせがありません\n    ")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }